<template>
    <section id="blog" class="blog" >
        <h5 class="center" >Blog (Portuguese BR only)</h5>
        <div id="post" >
            <div class="row row-post" :key="post" v-for="(post, key, index) in posts">
                <div class="col" >
                    <div class="left">
                      <i class="fa fa-calendar-o" ></i>
                      <time>{{ formataData(post.date) }}</time>
                    </div>
                    <br>                    
                    <div>
                      <a :href="post.link" class="scrollSoft left" ><h4 align="left">{{ post.title }} </h4></a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

import { scroll } from './common/jm-scroll'

import { formatDate } from './common/jm-date'

import { jsonData } from './common/jm-data'

export default {
  name: 'blog-component',
  data () {
    return {
      // posts: [],
      posts: jsonData(),
      postvisible: true,
      post: {}
    }
  },
  methods: {
    formataData (date) {
      return formatDate(date)
    }
  },
  mounted () {
    scroll('scrollSoft')
    this.$http.get('/post').then(response => (this.$data.posts = response.data))
  }
}
</script>

<style>

  @media only screen and (max-width: 577px) {
    post-title {
      font-size: 10px;
      text-align: left
    }
  }

  @media only screen and (min-width:321px) and (max-width:768px){
  }

  @media only screen and (min-width: 769px) {
  }

  .img{
    max-width: 100%;
    height: auto
  }

  .row {
    margin-left: 5%;
    margin-right: 5%;
  }

  .row-post {
    padding: 0 0 30px 0;
  }

  .blog{
    padding-top: 80px;
  }

</style>



// WEBPACK FOOTER //
// jm-c-blog.vue?6741623a